import { FormularyLookupForm } from "../Components/Forms";
import { FormularyLookupPageProps } from "../types";
import { SecondaryButton } from "@/Core/Components/Buttons";

const FormularyLookupPage = ({
    formulary,
    pageState,
}: FormularyLookupPageProps) => {
    return (
        <div className="w-full space-y-3">
            <FormularyLookupForm pageState={pageState} />

            {formulary && (
                <div className="px-4 group">
                    <SecondaryButton
                        className="items-center w-full h-10 mt-4 max-h-10"
                        onClick={() => {
                            window.open(
                                formulary?.link,
                                "_blank",
                                "rel=noopener noreferrer",
                            );
                        }}
                    >
                        Download Formulary
                    </SecondaryButton>
                </div>
            )}
        </div>
    );
};

export default FormularyLookupPage;
